import { Table } from '@mantine/core';

interface MinStdContextProps {
  context: Record<string, string>;
}

export function MinStdContext({ context }: MinStdContextProps) {
  return (
    <Table
      variant="vertical"
      withTableBorder
      bg="white"
    >
      <Table.Tbody>
        {Object.entries(context).map(([key, value]) => (
          <Table.Tr key={key}>
            <Table.Th w={250}>{key}</Table.Th>
            <Table.Td>{value}</Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}
